import { Component, EventEmitter, Output } from '@angular/core';
import { LocalizationPipe } from '@abp/ng.core';

@Component({
  selector: 'app-crm-segment-definitions-toolbar',
  standalone: true,
  imports: [LocalizationPipe],
  templateUrl: './crm-segment-definitions-toolbar.component.html',
  styleUrl: './crm-segment-definitions-toolbar.component.scss',
})
export class CrmSegmentDefinitionsToolbarComponent {
  @Output() addNew = new EventEmitter<void>();
}
